import useMobileClients from "./useMobileClients";

export default function useMobileDeviceInfo (deviceId) {
  const deviceInfo = useMobileClients((client) => client.device?.id === deviceId)[0]
  return deviceInfo;
}